export function fmtNumber(n: number | null | undefined): string {
  if (n == null) return '—';
  return n.toLocaleString('en-AU', { maximumFractionDigits: 0 });
}

export function fmtCurrency(n: number | null | undefined): string {
  if (n == null) return '—';
  return n.toLocaleString('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  });
}

export function fmtPercent(n: number | null | undefined, decimals = 1): string {
  if (n == null) return '—';
  return `${(n * 100).toFixed(decimals)}%`;
}

export function fmtDelta(n: number | null | undefined, suffix = '%'): {
  text: string;
  direction: 'up' | 'down' | 'neutral';
} {
  if (n == null || n === 0) return { text: '—', direction: 'neutral' };
  const direction = n > 0 ? 'up' : 'down';
  const arrow = n > 0 ? '▲' : '▼';
  return { text: `${arrow} ${Math.abs(n).toFixed(1)}${suffix}`, direction };
}

export function fmtSeconds(s: number | null | undefined): string {
  if (s == null) return '—';
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${String(sec).padStart(2, '0')}`;
}
